export var COMPANY_RESOURCE_TYPE;
(function (COMPANY_RESOURCE_TYPE) {
    COMPANY_RESOURCE_TYPE["SUBSCRIBER"] = "SUBSCRIBER";
})(COMPANY_RESOURCE_TYPE || (COMPANY_RESOURCE_TYPE = {}));
export var COMPANY_RESOURCE_ACCESS_TYPE;
(function (COMPANY_RESOURCE_ACCESS_TYPE) {
    COMPANY_RESOURCE_ACCESS_TYPE["OWNER"] = "OWNER";
    COMPANY_RESOURCE_ACCESS_TYPE["COLLABORATOR"] = "COLLABORATOR";
    COMPANY_RESOURCE_ACCESS_TYPE["VIEWER"] = "VIEWER";
})(COMPANY_RESOURCE_ACCESS_TYPE || (COMPANY_RESOURCE_ACCESS_TYPE = {}));
//# sourceMappingURL=company.js.map